<button
  type="button"
  (click)="toggle()"
  [title]="label()"
  [attr.aria-label]="'Order: ' + label() + ', click to reverse'"
  class="flex items-center rounded-lg bg-white p-2 text-gray-700 shadow-sm ring-1 ring-gray-200 transition-colors hover:bg-gray-50"
>
  <app-icon name="arrow-down" class="h-4 w-4 transition-transform" [class.rotate-180]="direction() === 'asc'" />
</button>
